export default "https://statics.cloudfastin.top/static/v1.27.25.1/store/images/google.png?79eb39902859fb0376c3d1462594cff0";